// extracted by mini-css-extract-plugin
export default {"root":"wAZ1HcNcE7tM8jlT8V3m","messageText":"DJ8_SdOO4Ib2s7_77rky","placeHolderShimmer":"CTNus0dMrn38WsxfvpVZ"};